import { useQuery } from '@tanstack/react-query';
import type { GroupMemberDto } from '@mondy/shared';
import { api } from '@/api';

interface GroupMembersResponse {
  members: GroupMemberDto[];
}

/**
 * Lists members of a group. Any member (owner or not) may view it; the server
 * returns 403 for non-members. Gate via the `enabled` flag so the call only
 * fires when the caller is already shown as a member (e.g. expanded row on
 * Profile).
 */
export function useGroupMembers(groupId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['groups', 'members', groupId] as const,
    queryFn: () =>
      api.get<GroupMembersResponse>(`/api/groups/${groupId}/members`),
    enabled: Boolean(groupId) && enabled,
    staleTime: 30_000,
  });
}
